export const translateTaskName = (taskName) => {
    const taskTranslations = {
        SERVICE_PROPOSAL: "Proposition de service",
        DESIGNATE_PARTIES: "Affectation des intervenant",
        UPLOAD_QUOTATION: "Ajout devis",
        UPLOAD_INVOICE: "Ajout facture",
        VALIDATE_QUOTATION: "Valider devis",
        VALIDATE_INVOICE: "Valider facture",
        CLIENT_PART_INFORMATION: "Confirmation client",
        REPARATION_MISSION_ACCEPTANCE: "Acceptation de mission de réparation",
        Upload_Payment_Proof: "Ajout quittance"
    };

    return taskTranslations[taskName] || taskName;
};
